import { useEffect, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { addEditServiceRequest, getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import { getQueryString } from "../../../../utils/Query";
import PropTypes from "prop-types";
import TableForm2s from "../../../../components/TableFormScrb";
import HeadData from "../../../../components/Perform/HeadData";
import ServiceRequestService from "../../../../services/servicerequest.service";
import ImageViewing from "./imageViewPrint";
import ConfirmModal from "../../../../components/ConfirmModal";
import FileUploadsService from "../../../../services/fileupload.service";

export default function DataServiceReq({ defaultData }) {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [defaultTableData, setDefaultTableData] = useState();
  const [tableData, setTableData] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allCountData, setAllCountData] = useState();
  const [optionReason, setOptionReason] = useState([]);
  const [arrayFileUpload, setArrayFileUpload] = useState();
  const [showImageViewing, setShowImageViewing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { setWebsiteName } = useWebsiteName();

  useEffect(() => {
    setJobType(defaultData.job_type)

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getReason(),
      callback: (res) => { setOptionReason(res) }
    });
  }, [defaultData]);

  const columns = {
    Standard: [{
      name: "detail",
      label: "ขั้นตอนการปฏิบัติงาน",
      type: "text",
      readOnly: true,
      width: "250px"
    },
    {
      name: "priority",
      label: "Priority",
      readOnly: true,
      width: "180px"
    },
    {
      name: "reason",
      label: "เหตุผลที่ข้ามขั้นตอน",
      type: "select",
      required: true,
      noneAsync: true,
      filterBy: ["Reason_Desc"],
      options: initializeSetOption({
        key: "Id",
        label: "Reason_Desc",
        dataset: optionReason
      }),
      width: "280px",
      showTooltip: false
    },
    {
      name: "file",
      label: "เพิ่มรูป",
      type: "addImage"
    },
    {
      name: "",
      label: "ดูรูปภาพ",
      type: "viewImage"
    },
    {
      name: "remark",
      label: "หมายเหตุ",
      type: "text"
    },
    ],
    Record: [
      {
        name: "detail",
        label: "ขั้นตอนการปฏิบัติงาน",
        type: "text",
        readOnly: true,
        width: "350px"
      },
      {
        name: "standard_value",
        label: "ค่ามาตรฐาน",
        readOnly: true,
      },
      {
        name: "record_value",
        label: "ค่าที่จดบันทึก",
        type: "number"
      },
      {
        name: "unit",
        label: "หน่วย",
        width: "100px",
        readOnly: true
      },
      {
        name: "file",
        label: "เพิ่มรูป",
        type: "addImage"
      },
      {
        name: "",
        label: "ดูรูปภาพ",
        type: "viewImage"
      },
      {
        name: "remark",
        label: "หมายเหตุ",
      },
    ],
    Check: [
      {
        name: "equip_no",
        label: "รหัสอุปกรณ์/อะไหล่",
        type: "text",
        width: "200px",
        readOnly: true
      },
      {
        name: "equip_detail",
        label: "รายละเอียดอุปกรณ์/อะไหล่",
        readOnly: true,
        width: "250px"
      },
      {
        name: "model_number",
        label: "Model Number",
        readOnly: true,
        width: "180px"
      },
      {
        name: "lumsum",
        label: "สัญญา LumSum",
        width: "200px",
        readOnly: true
      },
      {
        name: "expire_date",
        label: "วันหมดอายุ",
        readOnly: true,
      },
      {
        name: "check_date",
        label: "วันที่เช็คเปลี่ยน",
        readOnly: true
      },
      {
        name: "next_start",
        label: "วันที่เปลี่ยนครั้งต่อไประหว่าง",
        width: "250px",
        readOnly: true
      },
      {
        name: "end_start",
        label: "ถึงวัน",
        readOnly: true
      },
      {
        name: "plan_status",
        label: "สถานะตามแผน",
        readOnly: true
      },
      {
        name: "actual_status",
        label: "สถานะจริง",
        type: "select",
        noneAsync: true,
        filterBy: ["Status"],
        options: initializeSetOption({
          key: "Status",
          label: "Label",
          dataset: [
            { Status: "check", Label: "เช็ค", },
            { Status: "change", Label: "เปลี่ยน", }
          ]
        })
      },
      {
        name: "detail",
        label: "รายละเอียดการทำงาน",
        type: "select",
        noneAsync: true,
        // filterBy: ["Reason_Desc"],
        options: initializeSetOption({
          key: "Id",
          label: "Reason_Desc",
          dataset: optionReason
        }),
        width: "250px",
      },
      {
        name: "use_num",
        label: "จำนวนที่ใช้",
        type: "number",
      },
      {
        name: "use",
        label: "Use Flag",
        type: "select",
        noneAsync: true,
        filterBy: ["Status"],
        options: optionReason,
        options: initializeSetOption({
          key: "Status",
          label: "Status",
          dataset: [
            { Status: "Y", Use: true },
            { Status: "N", Use: false }
          ]
        })
      },
      {
        name: "file_before",
        label: "เพิ่มรูปก่อนทำ",
        type: "addImage",
        width: "140px",
      },
      {
        name: "",
        label: "ดูรูปก่อนทำ",
        type: "viewImage",
        width: "140px",
      },
      {
        name: "file_after",
        label: "เพิ่มรูปหลังทำ",
        type: "addImage",
        width: "140px",
      },
      {
        name: "",
        label: "ดูรูปหลังทำ",
        type: "viewImage",
        width: "140px",
      },
    ],
    Special: [
      {
        name: "detail",
        label: "รายละเอียดข้อกำหนดเพิ่มเติมตามสัญญา",
        type: "text",
        width: "400px",
        readOnly: true
      },
      {
        name: "other",
        label: "ข้อกำหนดเพิ่มเติมอื่นๆ",
        readOnly: true,
        width: "300px"
      },
      {
        name: "pm_no",
        label: "PM/ครั้งที่",
        readOnly: true,
        width: "180px"
      },
    ]
  }

  const headField = [
    {
      name: "contract_no",
      label: "สัญญาเลขที่",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      disabled: true,
      size: 2
    },
    {
      name: "job_type",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      size: 2
    },
    {
      name: "no",
      label: "ครั้งที่",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      disabled: true,
      size: 2
    },
    {
      name: "start",
      label: "วันที่ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      disabled: true,
      size: 2
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      disabled: true,
      size: 2
    },
    {
      name: "Ticket",
      label: "หมายเลข TicKet ลูกค้า",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.team,
      disabled: true,
      size: 2
    },
    {
      name: "contract_no",
      label: "สัญญาเลขที่",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.team,
      disabled: true,
      size: 4
    },

    {
      name: "contraact_type",
      label: "ประเภทสัญญา",
      classNames: { label: "mb-3" },
      size: 2,
    },
    {
      name: "start_contract",
      label: "วันเริ่มสัญญา",
      classNames: { label: "mb-3" },
      type: "date",
      size: 2,
    },
    {
      name: "end_contract",
      label: "วันสิ้นสุดสัญญา",
      classNames: { label: "mb-3" },
      type: "date",
      size: 2,
    },
    {
      name: "tect_mas_name",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      disabled: true,
      size: 2
    },
    {
      name: "cus_code",
      label: "รหัสลูกค้า/สาขา",
      readOnly: true
    },
    {
      name: "cus_no",
      label: "เลขที่สาขา",
      readOnly: true,
    },
    {
      name: "cus_name",
      label: "ชื่อลูกค้า/สาขา",
      readOnly: true,
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.team,
      disabled: true,
      size: 4
    },
    {
      name: "sq",
      label: "sq.",
      classNames: { label: "mb-3" },
      size: 2,
    },
    {
      name: "name",
      label: "ชื่อสินค้า",
      classNames: { label: "mb-3" },
      size: 2,
    },
    {
      name: "equip_no",
      label: "หมายเลขเครื่อง",
      classNames: { label: "mb-3" },
      size: 4,
    },
    {
      name: "project_no",
      label: "เลขโครงการ",
      classNames: { label: "mb-3" },
      size: 4,
    },
    {
      name: "start",
      label: "วันที่เข้างาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
    },
    {
      name: "start",
      label: "เวลา",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
    },

    {
      name: "location",
      label: "จุดที่ตั้งเครื่องจักร",
      classNames: { label: "mb-3" },
      size: 4,
    },
    {
      name: "status",
      label: "สถานะสาขา",
      classNames: { label: "mb-3" },
      size: 4,
    },
  ];

  function initData(data, mData) {
    // console.log(data, 'mData', mData)
    setLoading('loading')
    const dB = data?.BillOfReqDt?.map((items) => {
      const newArray = []
      const main = {
        Seq_No: data.SeqOthersJob?.Seq_Oth_No ||
          data.SeqPmJob?.Seq_Pm_No ||
          data.SeqRepairJob?.Seq_Serv_No ||
          data.SeqInstallJob?.Seq_Inst_No,
        Bill_Of_Req_Dt_Id: items.Id,
        Bill_Of_Hd_Id: items.Bill_Of_Hd_Id,

        No: "", //pm_no.pm_item   job_type_sub_mas.job_type_sub_name
        ProdSetMcId: items?.Item?.ProdSetMc?.Id,
        Sq: items?.Item?.ProdSetMc?.Seq_Work,
        Item_Name: items?.Item.Item_Name_TH || items?.Item.Item_Name_EN,
        Item_No: items?.Item.Item_Code, //
        Start: "", //job_start_date
        End: "",
        Ticket: "", //cus_ticket_no
        Location: items?.Item?.ProdSetMc?.Mc_Location,

      }

      items.Item.ChildBoms?.forEach(ele => {
        newArray.push({
          id: ele.Id,
          equip_no: ele.Item.Item_Code,
          equip_detail: ele.Item.Item_Name_TH || ele.Item.Item_Name_EN,
          model_number: ele.Item.Item_Model,
          lumsum: ele?.Foc?.FOC_ReasonName,
          expire_date: "",
          check_date: "",
          next_start: "",
          end_start: "",
          plan_status: "",//data.plan_status,
          actual_status: data.actual_status,
          detail: data.reason_id,
          use_num: data.item_use_qty,
          use: items.Use_Status,
          file_before: [],
          file_after: []
        })
      })
      return {
        ...main,
        tech_plan_id: items.ServiceRequestDt?.TechWorkJob?.tech_plan_id,
        tech_work_date: items.ServiceRequestDt?.TechWorkJob.tech_work_date,
        Id: items.Id,
        serviceReqDt: items.ServiceRequestDt?.TechWorkJob,
        tableCheck: newArray,
      }

    });
    setTableData(dB)
  }

  useEffect(() => {
    if (loading == 'loading') {
      setLoading(false)

      let params = ''
      const all = tableData.map(items => {
        const arrStandard = [], arrRecord = [], arrCheck = []
        items.serviceReqDt?.TechWorkSteps?.map(st => {
          const df = defaultTableData.tableStandard.find(t => t.item_step_des_id == st.item_step_des_id)
          arrStandard.push({
            work_step_id: st?.id,
            item_step_id: st.item_step_id,
            item_step_des_id: st?.item_step_des_id,
            detail: st?.Item_Step_Des || df?.detail,
            priority: st?.Item_Step_Priority || df?.priority,
            reason: st?.reason_id,
            remark: st?.remark,
            file: st?.TechWorkStepFile
          })
        })
        items.serviceReqDt?.TechWorkRecords?.map(rc => {
          const df = defaultTableData.tableRecord.find(t => t.id == rc.item_step_id)
          arrRecord.push({
            detail: rc?.Item_Record_Des || df?.detail,
            standard_value: rc?.Record_Value || df?.standard_value,
            record_value: rc?.actual_value,
            unit: rc?.Record_UOM || df?.unit,
            remark: rc?.remark,
            work_record_id: rc?.id,
            item_step_id: rc?.item_step_id || df?.id,
            file: rc?.TechWorkRecordFiles
          })
        })
        items.serviceReqDt?.TechWorkChecks?.map((ch, i) => {
          arrCheck.push({
            ...items.tableCheck[i],
            work_check_id: ch?.id,
            actual_status: ch?.actual_status,
            use_num: ch?.item_use_qty,
            plan_status: ch?.plan_status,
            detail: ch?.reason_id,
            file_before: ch?.TechWorkCheckFiles.filter(f => f.type == "before"),
            file_after: ch?.TechWorkCheckFiles.filter(f => f.type == "after")
          })
        })
        return {
          ...items,
          tableCheck: arrCheck.length ? arrCheck : items?.tableCheck,
          tableStandard: arrStandard.length ? arrStandard : defaultTableData?.tableStandard,
          tableRecord: arrRecord.length ? arrRecord : defaultTableData?.tableRecord
        }
      })
      setTableData(all)

    }
  }, [tableData])

  const getDataTable = async (search) => {
    if (!search?.seq_no) {
      setTableData([]);
      return
    }
    const q = getQueryString({
      seq_no: search.seq_no,
      page: 1,
      limit: 100
    })
    let dfData = {}
    if (!defaultTableData) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: ServiceRequestService.getItemStepDes(q),
        callback: (res) => {
          const arrayStep = res.map(el => ({
            item_step_id: el.Item_Step_Id,
            item_step_des_id: el.Id,
            detail: el.Item_Step_Des,
            priority: el.Item_Step_Priority,
            reason: el.Item_Step_Reason,
            remark: "",
            file: []
          }))
          dfData = { ...dfData, tableStandard: arrayStep }
        }
      });
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: ServiceRequestService.getContractSpec(q),
        callback: (res) => {
          const arraySp = res.map(el => ({
            detail: el.Con_Spec_Des,
            other: el.remark,
            pm_no: el.PM_Of_Work,
            id: el.Id,
          }))
          dfData = { ...dfData, tableSpecial: arraySp }
        }
      });
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: ServiceRequestService.getStandardRec(q),
        callback: (res) => {
          const array = res.map(item => ({
            detail: item.Item_Record_Des,
            standard_value: item.Record_Value,
            record_value: item.Actual_Value,
            unit: item.Record_UOM,
            remark: item.Remark,
            id: item.Id,
            file: []
          }))
          dfData = { ...dfData, tableRecord: array }
        }
      });
    }
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const qsearch = getQueryString({ ...search, limit: 100 })
    setCurrentPage(0)
    // setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: ServiceRequestService.getFindJobItem(qsearch),
      callback: async (res) => {
        if (!defaultTableData) setDefaultTableData(dfData)
        if (res.data.length) initData(res.data[0])
        // const data = await ServiceRequestService.getFindJob(q)
        // initData({ ...res.data, ...dfData }, data.data);
        setAllCountData(res.allCount)
      }
    });
  }

  const type = "Image"
  const destination = "service_request/Image"
  function uploadFileArray(array, name) {
    const itemFile = []
    const newArray = array.map((ele, i) => {
      ele.file?.forEach(file => {
        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: FileUploadsService.createFileUploads(destination, [file]),
          callback: async ({ files }) => {
            itemFile.push({
              "file_path": files[0],
              "file_type": type,
              type: name
            })
          },
        });
      })
      return { ...ele, [name || 'file']: itemFile }
    })
    return newArray
  };
  const formatToFile = (array) => {
    const Array = array.map(el => {
      return {
        ...el,
        file: el.file_before.concat(el.file_after)
      }
    })
    return uploadFileArray(Array)
  }

  function arrangeFiles(files, files_aft) {
    const newFiles = []
    files.filter(f => !f.id).forEach(el => {
      newFiles.push({
        ...arrayFileUpload.find(file => file.numb = el.lastModified + '_' + el.name),
        type: files_aft ? "before" : ""
      })
    })
    files_aft?.filter(f => !f.id).forEach(el => {
      newFiles.push({
        ...arrayFileUpload.find(file => file.numb = el.lastModified + '_' + el.name),
        type: "after"
      })
    })
    const all = files?.filter(f => f.id).concat(newFiles)
    if (files_aft) return all.concat(files_aft?.filter(f => f.id))
    return all
  }

  async function submit(e) {
    e.preventDefault();
    setShowModal(false)
    if (e.target.textContent == "ยืนยัน") {
      const arrayFiles = []
      for (let i in tableData) {
        const standard = await Promise.all(
          tableData[i].tableStandard.map(async st => {
            const newFile = st.file?.filter(e => !e.id)
            if (!newFile.length) return st
            const { files } = await FileUploadsService.createFileUploads(destination, [newFile[newFile?.length - 1]])
            if (files) return {
              ...st,
              "tech_work_step_file": [{
                "file_path": files[0],
                "file_type": type,
              }]
            }
          })
        )
        const record = await Promise.all(
          tableData[i].tableRecord.map(async st => {
            const newFile = st.file?.filter(e => !e.id)
            if (!newFile.length) return st
            const { files } = await FileUploadsService.createFileUploads(destination, [newFile[newFile?.length - 1]])
            if (files) return {
              ...st,
              "tech_work_record_file": [{
                "file_path": files[0],
                "file_type": type,
              }]
            }
          })
        )
        const check = await Promise.all(
          tableData[i].tableCheck.map(async el => {
            const b = el.file_before?.filter(e => !e.id)
            const a = el.file_after?.filter(e => !e.id)
            const resB = await FileUploadsService.createFileUploads(destination, [b[b?.length - 1]])
            const fileB = resB.files?.map(p => ({
              "file_path": p,
              "file_type": type,
              type: "before"
            }))
            const resA = await FileUploadsService.createFileUploads(destination, [a[a?.length - 1]])
            const fileA = resA.files?.map(p => ({
              "file_path": p,
              "file_type": type,
              type: "after"
            }))
            const all = fileA.concat(fileB)
            if (!all.length) return el
            return {
              ...el,
              "tech_work_check_file": all
            }
          })
        )
        arrayFiles.push({
          record,
          check,
          standard
        })
      }
      setArrayFileUpload(arrayFiles)
    }
  }

  useEffect(() => {
    if (arrayFileUpload) {
      const arrays = tableData.map((ele,ind) => (
        {
          bill_of_dt_id: ele.Bill_Of_Req_Dt_Id,
          "tech_work_job": {
            "tech_plan_id": ele?.tech_plan_id,
            "prod_set_mc_id": ele.ProdSetMcId,
            "tech_work_date": ele?.tech_work_date
          },
          "tech_work_step": ele.tableStandard.map((st,i) => ({
            "item_step_id": st.item_step_id,
            "item_step_des_id": st.item_step_des_id,
            "reason_id": st.reason,
            "remark": st.remark,
            work_step_id: st.work_step_id || undefined,
            "tech_work_step_file": arrayFileUpload[ind].standard[i].tech_work_step_file || []
          })),
          "tech_work_check": ele.tableCheck.map((el,i) => (
            {
              "item_child_id": el.id,
              "contract_foc_hd_id": el.contract_foc_hd_id,
              "tech_insp_rev_id": el.tech_insp_rev_id,
              "plan_status": el.plan_status,
              "actual_status": el.actual_status,
              "reason_id": el.detail,
              "item_use_qty": el.use_num,
              use_status: el.use,
              "tech_work_check_file": arrayFileUpload[ind].check[i].tech_work_check_file || [],
              work_check_id: el.work_check_id || undefined,
            }
          )),
          "tech_work_record": ele.tableRecord.map((rc,i) => (
            {
              "item_step_id": rc.item_step_id || rc.id,
              "actual_value": rc.record_value,
              "remark": rc.remark,
              "tech_work_record_file": arrayFileUpload[ind].record[i].tech_work_record_file || [],
              work_record_id: rc.work_record_id || undefined,
            }
          ))
        }
      ))
      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: ServiceRequestService.createWorkFlow({ 
          array: [
            {
              service_request: {
                tech_plan_id: tableData[0]?.tech_plan_id,
                bill_of_hd_id: tableData[0].Bill_Of_Hd_Id,
              },
              service_request_dt: arrays
            }
          ]
         }),
        navigated: () => {

        }
      });
    }
  }, [arrayFileUpload])

  return (
    !showImageViewing ?
      <>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Body>
            <div className="pb-4 fs-2 text-center">
              ข้อมูลการปฏิบัติงานตาม Service Request
            </div>

            <HeadData
              defaultData={defaultData}
              allData={tableData}
              searchCallback={getDataTable}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </Card.Body>
        </Card>

        <Form noValidate >
          <Card className="m-1 mb-4 p-4 border-0">
            <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
              <Card.Title className="mb-0 fs-2">
                ขั้นตอนการทำงานมาตรฐาน
              </Card.Title>
            </Card.Header>

            <Card.Body>
              <TableForm2s
                data={tableData[currentPage]?.tableStandard || []}
                columns={columns.Standard}
                editForm
                pagination={false}
                onChangeCallback={newData => {
                  const clone = [...tableData]
                  tableData[currentPage].tableStandard = newData
                  setTableData(clone)
                }}
                callbackImage={setShowImageViewing}
                minHeight='300px'
              />
            </Card.Body>
          </Card>
          <Card className="m-1 mb-4 p-4 border-0">
            <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
              <Card.Title className="mb-0 fs-2">
                คำสั่ง ตรวจสอบ/เปลี่ยน sparepart
              </Card.Title>
            </Card.Header>

            <Card.Body>
              <TableForm2s
                data={tableData[currentPage]?.tableCheck || []}
                columns={columns.Check}
                editForm
                pagination={false}
                isEditIndex
                onChangeCallback={newData => {
                  const use_ = newData.find((e, i) => i == e.isEdit)?.use
                  const newDatas = newData.map(el => (
                    { ...el, use: use_, isEdit: true }
                  ))

                  const clone = [...tableData]
                  tableData[currentPage].tableCheck = newDatas
                  setTableData(clone)
                }}
                minHeight='300px'
                callbackImage={setShowImageViewing}
              />
            </Card.Body>
          </Card>
          <Card className="m-1 mb-4 p-4 border-0">
            <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
              <Card.Title className="mb-0 fs-2">
                คำสั่งการบันทึกข้อมูล
              </Card.Title>
            </Card.Header>

            <Card.Body>
              <TableForm2s
                data={tableData[currentPage]?.tableRecord || []}
                columns={columns.Record}
                editForm
                pagination={false}
                onChangeCallback={newData => {
                  const clone = [...tableData]
                  tableData[currentPage].tableRecord = newData
                  setTableData(clone)
                }}
                minHeight='300px'
                callbackImage={setShowImageViewing}
              />
            </Card.Body>
          </Card>
          <Card className="m-1 mb-4 p-4 border-0">
            <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
              <Card.Title className="mb-0 fs-2">
                คำสั่งพิเศษ
              </Card.Title>
            </Card.Header>

            <Card.Body>
              <TableForm2s
                data={tableData.length ?
                  tableData[currentPage]?.tableSpecial || defaultTableData?.tableSpecial
                  : []}
                columns={columns.Special}
                editForm={false}
                pagination={false}
              />
            </Card.Body>
          </Card>

          <Card className="m-1 mb-4 p-4 border-0">
            <Card.Body className=" d-flex justify-content-center align-items-center">
              <Button
                variant="success"
                className="me-2 ms-3 mb-3 py-2 px-4 text-dark rounded-pill"
                onClick={() => tableData.length && setShowModal(true)}
              >
                บันทึกข้อมูล
              </Button>
              <ConfirmModal
                show={showModal}
                content={"add"}
                onSubmitCallback={submit}
              />
            </Card.Body>
          </Card>
        </Form>
      </> : (
        <ImageViewing
          arrayImage={showImageViewing}
          onClickBack={() => {
            setShowImageViewing(false); setWebsiteName("ข้อมูลการปฏิบัติงานตาม Service Request")
          }}
          destination={destination}
        />
      )
  );
}

DataServiceReq.propTypes = {
  defaultData: PropTypes.object,
};